import { useEffect } from 'react';
import { useFlagsSettled, useTrialAutoStartEnabled } from '../lib/featureFlags';
import { logEvent } from '../lib/telemetry';
import { clearTrialIntent, peekTrialIntent, readTrialIntent } from '../lib/trialIntent';

// Once the flags settle, a stored trial intent either belongs to a released trial flow or is
// dropped: settled off, it is cleared so nothing acts on it later in the session; settled on,
// reading it once reports (and drops) one that expired before anything used it.
export function useTrialIntentRelease(): void {
  const settled = useFlagsSettled();
  const enabled = useTrialAutoStartEnabled();
  useEffect(() => {
    if (!settled) return;
    if (enabled) {
      readTrialIntent();
      return;
    }
    // Reported only when a live intent goes, so the count is of trial links the flag turned away.
    const dropped = peekTrialIntent();
    clearTrialIntent();
    if (dropped) {
      logEvent('cloudhouse.enterprise.trial.intent_cleared_flag_off', 'Trial intent dropped: the trial flow is not released',
        { product: dropped.product }, 'INFO');
    }
  }, [settled, enabled]);
}
